import React, { CSSProperties, useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "react-i18next";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

interface IProps {
  load(): Promise<boolean>;
  children: React.ReactElement<any>;
  log_error: (val: any) => void;
}

const Loadable = (props: IProps) => {
  const { t } = useTranslation();
  const [error, setError] = useState<{ message: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [needRedirect, setNeedRedirect] = useState<boolean>(false);

  const load = () => {
    props
      .load()
      .then((value: boolean) => {
        setLoading(false);
        setNeedRedirect(value);
      })
      .catch((error: any) => {
        props.log_error(error);
        setError(error);
      });
  };

  useEffect(() => {
    load();
  }, []);

  if (error) {
    return (
      <div className="mx-auto mt-12 max-w-xl rounded-2xl border border-outline bg-surface p-6 shadow-sm">
        <h4 className="text-lg font-semibold text-text">{t("initial_app_load_failed")}</h4>
        <p className="mt-2 text-sm text-text-mid">{JSON.stringify(error.message)}</p>
        <button
          onClick={load}
          className="mt-5 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white transition hover:opacity-90"
        >
          {t("retry")}
        </button>
      </div>
    );
  }
  if (loading) {
    return (
      <div className="mx-auto mt-16 max-w-md rounded-2xl border border-outline bg-surface p-8 text-center shadow-sm">
        <ClipLoader cssOverride={override} color="var(--color-primary)" loading={true} />
        <p className="mt-4 text-sm text-text-mid">{t("loading_app")}</p>
      </div>
    );
  }

  if (needRedirect) {
    return (
      <div className="mx-auto mt-16 max-w-md rounded-2xl border border-outline bg-surface p-8 text-center shadow-sm">
        <ClipLoader cssOverride={override} color="var(--color-primary)" loading={true} />
        <h3 className="mt-4 text-base font-medium text-text">{t("app_loading_redirect_soon")}</h3>
      </div>
    );
  }

  return <>{React.cloneElement(props.children)}</>;
};

export default Loadable;
